/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';

import GroupType from '@linc-technologies/linced-common/enums/group-type';
import PersonType from '@linc-technologies/linced-common/enums/person-type';
import { hash } from '@linc-technologies/linced-common/utils/promise';
import moment from 'moment';

export default class ManageRoute extends Route {
  // Services
  @service
  store;

  model() {
    let person = this.modelFor('people.person').person;
    let personId = person.id;
    let year = moment().format('YYYY');
    return hash({
      person,
      applications: this.store.query('enrolments/application', { personId }),
      enrolments: this.store.query('people/enrolment', { personId }),
      learnerFields: this.store.query('people-schema/field', {
        personType: PersonType.LEARNER,
      }),
      homerooms: this.store.query('group', {
        year,
        groupType: GroupType.HOMEROOM,
      }),
    });
  }

  resetController(controller) {
    controller.reset();
  }
}
